<!-- Loading -->
<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>

<!-- Error Section -->
<div *ngIf="error" class="w-full flex items-center justify-center ">
    <app-error-page></app-error-page>

</div>

<!-- Booking Success Section -->
<div *ngIf="bookingSuccess && !error && !loading" class="w-full flex items-center justify-center">
    <app-reschedule-success [bookingSlotTime]="bookingSlotTime" [bookingdata]="session"
        class="w-full flex"></app-reschedule-success>
</div>

<!-- Main Booking Section -->
<div *ngIf="!bookingSuccess && !error" class="w-full grow bg-slate-100">

    <form [formGroup]="slot_form">
        <div class="flex p-6 grow" *ngIf="this.bookingPageData.accountSession.calendar_view== 'DAY'">

            <!-- Left Sidebar -->
            <div class="w-1/4 p-4 bg-white rounded-md shadow">
                <div class="grid grid-cols-1">
                    <div class="flex px-2 py-3 border-b">
                        <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:user"
                            matTooltip="Name"></mat-icon>
                        <div class="ml-3">
                            <div class="font-medium leading-6 text-primary">
                                Name
                            </div>
                            <div class="mt-0.5 text-secondary">
                                {{this.session.client_first_name}} &nbsp; {{this.session.client_last_name}}
                            </div>
                        </div>
                    </div>
                    <div class="flex px-2 py-3 border-b">
                        <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:envelope"
                            matTooltip="Email Address"></mat-icon>
                        <div class="ml-3">
                            <div class="font-medium leading-6 text-primary">
                                Email
                            </div>
                            <div class="text-gray-500 text-sm">
                                {{this.session.client_email}}
                            </div>
                        </div>
                    </div>

                    <div class="flex px-2 py-3 border-b">
                        <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:calendar"
                            matTooltip="Email Address"></mat-icon>
                        <div class="ml-3">
                            <div class="font-medium leading-6 text-primary">
                                Date
                            </div>
                            <div class="mt-0.5 text-secondary">
                                {{this.session.appointment_start_time | date:'MMM dd, h:mm a'}}
                            </div>
                        </div>
                    </div>

                    <div class="flex px-2 py-3 border-b" *ngIf="this.session.amount">
                        <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:globe-alt"
                            matTooltip="Amount"></mat-icon>
                        <div class="ml-3">
                            <div class="font-medium leading-6 text-primary">
                                Amount
                            </div>
                            <div class="mt-0.5 text-secondary">
                                {{this.session.amount}}
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- Calendar Section -->
            <div class="w-2/4 p-4 ml-4 bg-white rounded-md shadow">
                <div class="flex border-b justify-between items-center ">
                    <h2 class="text-lg font-semibold text-primary-500  mb-0">Select a Date</h2>
                    <div class="flex px-2 py-3 items-center">
                        <mat-icon class="text-primary-500 dark:text-primary-500 icon-size-5"
                            svgIcon="heroicons_outline:calendar" matTooltip="Select a date"></mat-icon>
                        <div class="ml-3">
                            <div *ngIf="selectedDate" class="text-primary text-secondary">
                                {{selectedDate}}
                            </div>
                            <div *ngIf="!selectedDate" class="text-red-400">
                                Please select a date
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-center items-center transform ">
                    <div class="cal-picker custom-calendar" >
                        <ngb-datepicker formControlName="calenderSelectedDate" [minDate]="minDate"
                            [maxDate]="maxDate" (dateSelect)="onDateSelect()"></ngb-datepicker>
                    </div>

                </div>
            </div>

            <!-- Time Slots Section -->
            <div class="w-1/3 p-4 ml-4  bg-white rounded-md shadow overflow-scroll max-h-128">
                <div *ngIf="timeSlotsUI[0]?.slots.length" class="flex justify-between items-center border-b ">
                    <h2 class="text-lg font-semibold text-primary-600  ">Select Slot</h2>
                    <div class="flex px-2 py-3">
                        <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:clock"
                            matTooltip="Email Address"></mat-icon>
                        <div class="ml-3">
                            <div *ngIf="selectedSlot?.time" class="mt-0.5 text-secondary">
                                {{selectedSlot?.time}}
                            </div>
                            <div *ngIf="!selectedSlot?.time" class="mt-0.5 text-red-400">
                                please select slot
                            </div>
                        </div>
                    </div>
                </div>

                <fuse-alert *ngIf="!timeSlotsUI[0]?.slots.length && !loading" [type]="'warn'" [appearance]="'outline'"
                    class="drop-shadow select-none my-3">
                    <b>Info: </b> No slots available
                </fuse-alert>

                <div class="date-picker-time" *ngIf="selectedDate">

                    <div class="d-flex flex-column time-slots-column">
                        <ng-container *ngFor="let slot of timeSlotsUI[0]?.slots; let i = index">
                            <div class="flex justify-between gap-2 w-full">
                                <button type="button" (click)="onTimeSlotClick(slot)"
                                    class="fuse-mat-button-small mt-2 time-slot-btn w-full" mat-raised-button [ngClass]="{
                                            'selected-slot': selectedSlot.uuid === slot.uuid,
                                            'booked-slot': !slot.available,
                                            'available-slot':slot.available && selectedSlot.uuid !== slot.uuid
                                        }" [disabled]="!slot.available || selectedSlot.uuid === slot.uuid">
                                    <span class="slot-text">
                                        <mat-icon *ngIf="!slot.available">lock</mat-icon>
                                        <mat-icon *ngIf="selectedSlot.uuid === slot.uuid">check_circle</mat-icon>
                                        {{ slot.time }}
                                    </span>
                                </button>
                            </div>
                        </ng-container>
                        <div *ngIf="!timeSlotsUI.length && !loading">
                            <ng-lottie class="flex justify-center" #lotani [options]="lottieConfig"
                                (animCreated)="handleAnimation($event)">
                            </ng-lottie>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="flex p-6 grow" *ngIf="this.bookingPageData.accountSession.calendar_view== 'WEEK'">

            <!-- Left Sidebar -->
            <div class="w-1/4 p-4 bg-white rounded-md shadow  flex flex-col">
                <div class="grid grid-cols-1">
                    <!-- <div class="text-left">
                        <h3 class="font-semibold mb-2">Booking Details:</h3>
                        <div class="space-y-1">
                          <p><span class="font-semibold">Name:</span>  {{this.session.client_first_name}}&nbsp;{{this.session.client_last_name}}</p>
                          <p><span class="font-semibold">Email:</span>  {{this.session.client_email}}</p>
                          <p><span class="font-semibold">Date:</span> {{this.session.appointment_start_time | date:'MMM dd, h:mm a'}}</p>
                          <p *ngIf="this.session.amount"><span class="font-semibold">Amount</span> {{this.session.amount}}</p>
                        
                        </div>
                      </div> -->
                    <div class="flex px-2 py-3 border-b">
                        <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:user"
                            matTooltip="Name"></mat-icon>
                        <div class="ml-3 flex w-full justify-between items-center">
                            <div class="font-medium leading-6 text-primary basis-0 grow-1">
                                Name
                            </div>
                            <div class="mt-0.5 text-secondary basis-0 grow-6">
                                {{this.session.client_first_name}}&nbsp;{{this.session.client_last_name}}
                            </div>
                        </div>
                    </div>
                    <div class="flex px-2 py-3 border-b ">
                        <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:envelope"
                            matTooltip="Email Address"></mat-icon>
                        <div class="ml-3 flex justify-between items-center w-full">
                            <div class="font-medium leading-6 text-primary">
                                Email
                            </div>
                            <div class="text-gray-500 text-sm">
                                {{this.session.client_email}}
                            </div>
                        </div>
                    </div>

                    <div class="flex px-2 py-3 border-b">
                        <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:calendar"
                            matTooltip="Email Address"></mat-icon>
                        <div class="ml-3 flex justify-between items-center w-full">
                            <div class="font-medium leading-6 text-primary">
                                Date
                            </div>
                            <div class="mt-0.5 text-secondary">
                                {{this.session.appointment_start_time | date:'MMM dd, h:mm a'}}
                            </div>
                        </div>
                    </div>

                    <div class="flex px-2 py-3 border-b" *ngIf="this.session.amount">
                        <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:globe-alt"
                            matTooltip="Amount"></mat-icon>
                        <div class="ml-3">
                            <div class="font-medium leading-6 text-primary">
                                Amount
                            </div>
                            <div class="mt-0.5 text-secondary">
                                {{this.session.amount}}
                            </div>
                        </div>
                    </div>

                </div>

                <!-- calendar -->
                <div class="cal-picker self-center">
                    <ngb-datepicker #dp formControlName="calenderSelectedDate" [minDate]="minDate"
                        [maxDate]="maxDate" (dateSelect)="onDateSelect()"></ngb-datepicker>
                </div>
            </div>

            <!-- Time Slots Section -->
             <!-- Card-3 Time Slots Section -->
             <div class="w-full p-3 md:w-10/12  bg-white  md:ml-4">
                               
                <div *ngIf="timeSlotsUI.length"
                    class="flex justify-between items-center border-b animate-in fade-in duration-500">
                    <div *ngIf="!allBooked" class="flex items-center justify-between w-full ">
                        <h2 class="text-md font-semibold text-primary-500">Select Booking Slot</h2>
                        <div class="flex px-2 py-3 items-center">
                            <mat-icon class="text-primary dark:text-primary-500 icon-size-5"
                                svgIcon="heroicons_outline:clock"></mat-icon>
                            <div class="ml-3 flex align-center items-center">
                                <div *ngIf="selectedSlot?.time" class="text-primary">
                                    {{selectedSlot?.localUtcDate| date:'MM-dd-yyyy':'UTC' }} 
                                    {{selectedSlot?.localUtcDate| date:'hh:mm aa':'UTC' }} 
                                </div>
                                <div *ngIf="!selectedSlot?.time && !allBooked" class="text-red-500">
                                    Select a time
                                </div>

                            </div>
                        </div>
                    </div>

                    <fuse-alert *ngIf="allBooked && !loading" [type]="'warn'" [appearance]="'outline'"
                        class="drop-shadow select-none w-full my-3">
                        <b>Info: </b> All Slots Booked
                    </fuse-alert>
                </div>

                <fuse-alert *ngIf="!timeSlotsUI.length && !loading" [type]="'warn'"
                    [appearance]="'outline'" class="drop-shadow select-none my-3">
                    <b>Info: </b> No slots available
                </fuse-alert>

                <div class=" relative flex  date-picker-time justify-evenly gap-2  flex-row   py-2"
                    *ngIf="selectedDate ">
                    <div (click)="onDateSelect('prev')" style="left: 0; top: 16px;" class="absolute  group inline-block">
                        <!-- Tooltip -->
                        <div class="absolute bottom-full mb-2 hidden group-hover:block bg-gray-800 text-white text-sm rounded px-2 py-1 whitespace-nowrap">
                          Previous Week
                        </div>
                      
                        <!-- Circular button -->
                        <button class="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center shadow">
                          <svg class="w-4 h-4 text-gray-700" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
                          </svg>
                        </button>
                      </div>
                      <div style="right: 0; top: 16px;" class="absolute group inline-block">
                        <!-- Tooltip -->
                        <div class="absolute bottom-full mb-2 hidden group-hover:block bg-gray-800 text-white text-sm rounded px-2 py-1 whitespace-nowrap">
                          Next Week
                        </div>
                      
                        <!-- Circular button -->
                        <button (click)="onDateSelect('next')" class="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center shadow">
                          <svg class="w-4 h-4 text-gray-700" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                          </svg>
                        </button>
                      </div>
                    <div *ngFor="let ws of this.timeSlotsUI; let i = index"
                        class="flex items-center  flex-col time-slots-column  grow  max-w-32">
                        <div
                        [matTooltip]="ws.date | date"
                            class="w-10 h-10 border-primary-500 rounded-full text-dark border flex p-6 mt-2 items-center justify-center">
                            <div class="text-center leading-tight">
                                <div class="text-xs">{{ws.day}}</div>
                                <div class="text-lg font-semibold">{{ws.dateDay}}</div>
                            </div>
                        </div>
                        <ng-container *ngFor="let slot of ws.slots; let i = index; let first = first"
                            class="pt-12">
                            <div class="flex justify-between pt-1  flex-col gap-2 w-full "
                                [ngClass]="{ 'pt-6': first }">
                                <button *ngIf="slot.time!='--'" type="button "  (click)="onTimeSlotClick(slot)"
                                    class="text-blue-700 hover:text-white border  border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm p-2 text-center me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800 whitespace-nowrap"
                                    [ngClass]="{
                                        'selected-slot': selectedSlot.uuid === slot.uuid,
                                        'booked-slot': !slot.available,
                                        'available-sl': slot.available && selectedSlot.uuid !== slot.uuid
                                    }" [disabled]="!slot.available || selectedSlot.uuid === slot.uuid">
                                    <span class="slot-text text-center justify-center">
                                        <mat-icon *ngIf="!slot.available"
                                            svgIcon="heroicons_outline:lock-closed"
                                            class="icon-size-4"></mat-icon>
                                        <mat-icon class="icon-size-4" *ngIf="selectedSlot.uuid === slot.uuid"
                                            svgIcon="heroicons_outline:check-circle"></mat-icon>
                                        {{ slot.time }}
                                    </span>
                                </button>
                                <button *ngIf="slot.time=='--'" type="button " disabled
                                class=""
                              >
                                <span class="slot-text  text-gray-400 text-center justify-center pb-4 mb-2">
                                   __
                                </span>
                            </button>

                               
                            </div>
                        </ng-container>
                        <div *ngIf="!timeSlotsUI.length && !loading">
                            <ng-lottie class="flex justify-center" #lotani>
                            </ng-lottie>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </form>


    <div class="flex justify-end mt-2 p-3">
        <button [disabled]="!isFormsValid()" (click)="submitBooking()" mat-raised-button color="primary"
            class="w-40  text-white" type="submit">
            Reschdedule
        </button>
    </div>

</div>